import React, { useEffect, useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { GET_DMT_TRANS_HISTORY, POST_DMT_REFUND_TRANSACTION, GET_DMT_TRANSACTION_INQUIRY, POST_PAY_SPRINT_REFUND_OTP_REQUEST, POST_PAY_SPRINT_REFUND_REQUEST, POST_INSTANT_PAY_REFUND_OTP_REQUEST, POST_INSTANT_PAY_REFUND_REQUEST } from './../../Utils/appConstants';
import { dmtStatus, dmtDetailStatus, channelStatus, isNumber, getFinalDmtStatus } from './../../Utils/Common';
import { getRequest, postRequest } from './../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import DmtInvoice from "../../container/dmtInvoice";
import { DatePicker, Modal, Tooltip, Table, Space, Tag } from 'antd';
import { getUTCToLocalDateTimeFormat, queryDate, toDayDate } from '../../Utils/function';
import moment from 'moment';

/* ============================================================
   PERSISTENCE HELPERS
============================================================ */
const FILTERS_STORAGE_KEY = 'dmtHistoryFilters';
const RESTORE_FLAG_KEY = 'dmtHistoryRestore';

const consumeRestoreFlag = () => {
    try {
        const flag = sessionStorage.getItem(RESTORE_FLAG_KEY);
        if (flag === '1') {
            sessionStorage.removeItem(RESTORE_FLAG_KEY);
            return true;
        }
    } catch { /* ignore */ }
    return false;
};

const loadSavedFilters = () => {
    if (!consumeRestoreFlag()) {
        try { sessionStorage.removeItem(FILTERS_STORAGE_KEY); } catch { /* ignore */ }
        return {};
    }
    try {
        const raw = sessionStorage.getItem(FILTERS_STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

const restoreDate = (str) => {
    if (!str) return toDayDate();
    const m = moment(str, 'DD-MM-YYYY');
    return m.isValid() ? m : toDayDate();
};
/* ============================================================ */

function DmtHistory(props) {

    const history = useHistory();
    const limit = 10;
    const dateFormat = 'DD-MM-YYYY';

    const [saved] = useState(() => loadSavedFilters());

    const [searchAccountNumber, setSearchAccountNumber] = useState(saved.searchAccountNumber || '');
    const [searchTransId, setSearchTransId] = useState(saved.searchTransId || '');
    const [searchCustomerId, setSearchCustomerId] = useState(saved.searchCustomerId || '');

    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(restoreDate(saved.endDate));
    const [startDate, setStartDate] = useState(restoreDate(saved.startDate));
    const [getData, setData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [refundData, setRefundData] = useState(null);
    const [refundOtpRef, setRefundOtpRef] = useState(null);
    const [page, setPage] = useState(saved.page || 1);
    const [isLimit, setLimit] = useState(saved.isLimit || limit);
    const [userId, setUserId] = useState(props.userId);
    const [isOtp, setOtp] = useState(null);
    const [isOtpModal, setOtpModal] = useState(false);

    const [invoiceDataModal, setInvoiceDataModal] = useState(false);
    const [invoiceData, setInvoiceData] = useState(null);

    const [otpTimer, setOtpTimer] = useState(45);
    const [isTimerActive, setIsTimerActive] = useState(false);

    const [forceFetch, setForceFetch] = useState(false);

    const isFirstRun = useRef(true);

    const columns = [{
        name: 'Date Time',
        cell: row => getUTCToLocalDateTimeFormat(row.createdAt),
        width: "200px",
    }, {
        name: 'Trans ID',
        selector: row => <Tooltip placement="bottom" title={row.client_ref_id}>{row.client_ref_id}</Tooltip>,
        width: "180px",
    }, {
        name: 'Customer ID',
        selector: row => <Tooltip placement="bottom" title={row.customer_id}>{row.customer_id}</Tooltip>,
        width: "130px",
    }, {
        name: 'Bank Name',
        selector: row => (row.baneData && row.baneData.bankName) || (row.baneData1 && row.baneData1.bankName),
        width: "220px",
    }, {
        name: 'IFSC Code',
        selector: row => row.baneData ? row.baneData.ifscCode : (row.baneData1) ? row.baneData1.ifscCode : "",
        width: "150px",
    }, {
        name: 'Account Number',
        selector: row => row.baneData ? row.baneData.accountNumber : (row.baneData1) ? row.baneData1.accountNumber : "",
        width: "170px",
    }, {
        name: 'Bene Name',
        selector: row => row.baneData ? (row.baneData.beneBankName ? row.baneData.beneBankName : row.baneData.beneName) : (row.baneData1) ? (row.baneData1.beneBankName ? row.baneData1.beneBankName : row.baneData1.beneName) : "",
        width: "190px",
    }, {
        name: 'Mode',
        selector: row => channelStatus(row.channel),
        width: "100px",
    }, {
        name: 'Amount',
        selector: row => row.amount + ' ' + row.currency,
        width: "100px",
    }, {
        name: 'Status',
        selector: row => dmtStatus(row.txtStatus),
    }, {
        name: 'Action',
        selector: row => <><button type="button" className='btn btn-sm border border-success text-success' onClick={() => handleInvoice(row)} title='Print Invoice'><i class="fa fa-print" aria-hidden="true"></i></button></>,
        width: "250px",
    },
    {
        name: 'Message',
        selector: row => <Tooltip placement="bottom" title={row.message && row.message}>{row.message && row.message}</Tooltip>,
        width: "200px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }]

    const handleInvoice = (data) => {
        try { sessionStorage.setItem(RESTORE_FLAG_KEY, '1'); } catch { /* ignore */ }
        setInvoiceData(data);
        history.push(`/dmtinvoice/${data.client_ref_id}`);
    }

    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        setLoading(true);
        if (data) {
            setLimit(data);
            params.limit = data;
        }
        if (startDate && endDate) {
            params.startDate = startDate ? queryDate(startDate) : "";
            params.endDate = endDate ? queryDate(endDate) : "";
        }
        if (props.userId) {
            params.userId = userId ? userId : props.userId;
        }
        params.searchTransId = searchTransId ? searchTransId : "";
        params.searchAccountNumber = searchAccountNumber ? searchAccountNumber : "";
        params.searchCustomerId = searchCustomerId ? searchCustomerId : "";
        params.page = Math.max(1, page);

        const queryString = objectToQueryString(params);
        getRequest(`${GET_DMT_TRANS_HISTORY}?${queryString}`, history)
            .then((response) => {
                if (response.success === true) {
                    setData(response.data);
                    setTotalRecord(response.data.totalDocs);
                } else {
                    toast.error(response.message || 'Failed to fetch transaction history');
                    setData([]);
                    setTotalRecord(0);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                toast.error('Network error or server error');
                setLoading(false);
            });
    };

    const transactionInquiry = (data) => {
        setLoading(true)
        const payload = { transactionId: data.transactionId };
        let URL = GET_DMT_TRANSACTION_INQUIRY;
        postRequest(`${URL}`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                getDataReports();
            } else {
                toast.error(response.message);
                getDataReports();
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
        })
    }

    const refundTransaction = (data) => {
        setRefundData(data);
        const prefix = data?.transactionId?.slice(0, 2);
        setLoading(true);
        const payload = { transactionId: data.transactionId };
        let URL;
        if (prefix === "SP") {
            URL = POST_PAY_SPRINT_REFUND_OTP_REQUEST;
        } else {
            URL = POST_INSTANT_PAY_REFUND_OTP_REQUEST;
        }
        postRequest(`${URL}`, payload, history)
            .then((response) => {
                if (response.success === true) {
                    if (response.data?.referenceKey) {
                        setRefundOtpRef(response.data?.referenceKey);
                    }
                    setOtpModal(true);
                    toast.success(response.message);
                    if (prefix === "SI" || prefix === "SN") {
                        setOtpTimer(45);
                        setIsTimerActive(true);
                    }
                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    useEffect(() => {
        let interval;
        if (isTimerActive && otpTimer > 0) {
            interval = setInterval(() => {
                setOtpTimer(prev => prev - 1);
            }, 1000);
        }
        if (otpTimer === 0 && isTimerActive) {
            clearInterval(interval);
            setIsTimerActive(false);
            setOtpModal(false);
            toast.error("OTP expired after 45 seconds. Please initiate refund again.");
        }
        return () => clearInterval(interval);
    }, [otpTimer, isTimerActive]);

    const handleRefundTransaction = () => {
        setLoading(true)
        const payload = {
            transactionId: refundData.transactionId,
            otp: isOtp
        }
        let URL;
        if (refundData && refundData.transactionId.includes("SP")) {
            URL = POST_PAY_SPRINT_REFUND_REQUEST;
        } else {
            URL = POST_INSTANT_PAY_REFUND_REQUEST;
            payload.referenceKey = refundOtpRef;
        }
        postRequest(`${URL}`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                getDataReports();
            } else {
                toast.error(response.message);
            }
            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
        })
    }

    const handlePageChange = (page, size) => {
        setPage(Math.max(1, parseInt(page)));
    };

    const onChangeStartDate = (date, dateString) => {
        setStartDate(date)
    };

    const onChangeEndDate = (date, dateString) => {
        setEndDate(date)
    };

    const handleHideModal = () => {
        setOtpModal(false);
        setInvoiceDataModal(false);
        setIsTimerActive(false);
        setOtpTimer(45);
    };

    const handleSearch = () => {
        setPage(1);
        setForceFetch(prev => !prev);
    }

    const handleClear = () => {
        try {
            sessionStorage.removeItem(FILTERS_STORAGE_KEY);
            sessionStorage.removeItem(RESTORE_FLAG_KEY);
        } catch { /* ignore */ }

        setStartDate(toDayDate());
        setEndDate(toDayDate());
        setSearchAccountNumber('');
        setSearchTransId('');
        setSearchCustomerId('');
        setPage(1);
        setForceFetch(prev => !prev);
    }

    /* ============================================================
       PERSIST FILTERS ON EVERY CHANGE
    ============================================================ */
    useEffect(() => {
        const toSave = {
            startDate: startDate ? moment(startDate).format(dateFormat) : null,
            endDate: endDate ? moment(endDate).format(dateFormat) : null,
            searchAccountNumber,
            searchTransId,
            searchCustomerId,
            page,
            isLimit,
        };
        try {
            sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(toSave));
        } catch { /* ignore */ }
    }, [
        startDate, endDate,
        searchAccountNumber, searchTransId, searchCustomerId,
        page, isLimit,
    ]);
    /* ============================================================ */

    useEffect(() => {
        if (props.userId) {
            setUserId(props.userId)
        }
        getDataReports();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        getDataReports();
    }, [page, forceFetch]); // eslint-disable-line react-hooks/exhaustive-deps

    const ExpandableComponent = (props, key) => <div className="ml-5 w-50"><Table dataSource={props.data.dmttransactiondetails} key={key} columns={[
        {
            title: 'Transaction Id',
            dataIndex: 'transactionId',
            key: 'transactionId',
        }, {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
        }, {
            title: 'Bank RRN',
            dataIndex: 'bank_ref_num',
            key: 'bank_ref_num',
        }, {
            title: 'Status',
            key: 'txstatus_desc',
            render: (record, key) => (
                <><Space key={key} size="middle">{dmtDetailStatus(record.tx_status)}</Space></>
            )
        }, {
            title: "Action",
            key: "action",
            render: (record, key) => (
                <><Space key={key} size="middle">
                    {(
                        !record.isRefund &&
                        (
                            (record.transactionId?.startsWith("SP") && record.tx_status === "3") ||
                            (record.optional7 === "ReversalAuthorisationRequired" &&
                                ["SI", "SN"].some(prefix => record.transactionId?.startsWith(prefix)))
                        )
                    ) && (
                            <Tag color="green" onClick={() => refundTransaction(record)} className="pointer">
                                REFUND
                            </Tag>
                        )}
                    {!record.isRefund && (record.tx_status === "0" || record.tx_status === "1" || record.tx_status === "2" || record.tx_status === "3" || record.tx_status === "5" || record.tx_status === "8") &&
                        <Tag color={"yellow"} onClick={() => transactionInquiry(record)} className='pointer'>
                            INQUIRY
                        </Tag>
                    }
                </Space></>
            )
        }, {
            title: 'Message',
            dataIndex: 'reason',
            key: 'reason',
        }
    ]} />
    </div>

    return (
        <div className="">
            <div className="content p-0">
                <div className="container-fluid">
                    <div className='card'>
                        <div className='card-body'>
                            <div className="row">
                                <div className='col-md-12 date-search mb-0'>
                                    <div className='row'>
                                        <div className='col-md-4 col-lg-4 d-flex'>
                                            <div className="form-group mr-3">
                                                <label className='date-search-label mb-0 text-blue'>From</label>
                                                <DatePicker className="form-control form-control-border" value={startDate} format={dateFormat} onChange={onChangeStartDate} />
                                            </div>
                                            <div className="form-group">
                                                <label className='date-search-label mb-0 text-red'>To</label>
                                                <DatePicker className="form-control form-control-border" value={endDate} format={dateFormat} onChange={onChangeEndDate} />
                                            </div>
                                        </div>
                                        <div className='col-md-2 col-lg-2'>
                                            <div className="form-group">
                                                <label className='date-search-label mb-0 text-red'></label>
                                                <input type="text" className="form-control form-control-border" placeholder="Trans ID" value={searchTransId} onChange={(e) => setSearchTransId(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='col-md-2 col-lg-2'>
                                            <div className="form-group">
                                                <label className='date-search-label mb-0 text-red'></label>
                                                <input type="text" className="form-control form-control-border" placeholder="A/C Number" value={searchAccountNumber} onChange={(e) => setSearchAccountNumber(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='col-md-2 col-lg-2'>
                                            <div className="form-group">
                                                <label className='date-search-label mb-0 text-red'></label>
                                                <input type="text" className="form-control form-control-border" placeholder="Customer ID" value={searchCustomerId} onChange={(e) => setSearchCustomerId(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className='col-md-1 col-lg-1'>
                                            <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                                            <button type="submit" className="btn btn-primary rounded-pill px-3" onClick={() => handleSearch()}>Search</button>
                                        </div>
                                        <div className='col-md-1 col-lg-1'>
                                            <div><label className='date-search-label mb-0 text-red'>&nbsp;</label></div>
                                            <button type="submit" className="btn btn-default rounded-pill px-4" onClick={() => handleClear()}>Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid pt-2 pb-5">
                                <DataTable
                                    title={""}
                                    columns={columns}
                                    data={getData.docs}
                                    defaultSortFieldID={1}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    expandableRows
                                    expandableRowsComponent={ExpandableComponent}
                                    progressPending={isLoading}
                                    paginationTotalRows={getTotalRecord}
                                    paginationDefaultPage={page}          /* 👈 restore page index */
                                    paginationPerPage={isLimit}           /* 👈 restore page size */
                                    onChangeRowsPerPage={getDataReports}
                                    onChangePage={handlePageChange}
                                />
                            </div>
                        </div>
                    </div>

                    {isOtpModal &&
                        <Modal title={"OTP CODE"} width={600} open={isOtpModal} onCancel={handleHideModal} footer={null}>
                            <>
                                <div className='row'>
                                    {isTimerActive && (
                                        <div className='col-md-12 text-center mb-2'>
                                            <div style={{ color: "red", fontWeight: "600", fontSize: "14px" }}>
                                                ⏳ OTP expires in {otpTimer} seconds
                                            </div>
                                        </div>
                                    )}
                                    <div className='col-md-12 form-group'>
                                        <label>OTP Number: </label>
                                        <input type='text' className="form-group form-control" onChange={(e) => setOtp(e.target.value)} maxLength={6} value={isOtp} onKeyDown={isNumber} />
                                    </div>
                                    <div className='col-md-12 form-group text-right'>
                                        <button type='button' onClick={handleHideModal} className='btn btn-sm btn-default mr-2'>Cancel</button>
                                        <button type='button' onClick={handleRefundTransaction} className='btn btn-sm btn-primary' disabled={isTimerActive && otpTimer === 0}>Send</button>
                                    </div>
                                </div>
                            </>
                        </Modal>
                    }

                    {invoiceDataModal && (
                        <Modal open={invoiceDataModal} width="70%" footer={null} onCancel={handleHideModal} closable={false} maskClosable={false}>
                            <DmtInvoice transactionId={invoiceData.client_ref_id} onClose={handleHideModal} />
                        </Modal>
                    )}
                </div>
            </div>
        </div>
    )
}

export default DmtHistory;